import React, { useState } from 'react';
import ShortcutInfoModal from './ShortcutInfoModal';
import { shortcutItems, ShortcutItem } from './shortcutConfig';

import { ReactComponent as KeyboardIcon } from '../assets/header/keyboard.svg';

type Props = {
  items?: ShortcutItem[];
  color?: string;
};

export default function ShortcutInfoButton({ items = shortcutItems, color }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <KeyboardIcon onClick={() => setOpen(true)} style={{ cursor: 'pointer', color }} />

      <ShortcutInfoModal open={open} onClose={() => setOpen(false)} items={items} />
    </>
  );
}
